export default __webpack_public_path__ + "static/media/VO_HAMBURGER.ca440b37.svg";